import { useQuery } from '@tanstack/react-query'
import { ApiAgentRequest, request } from '../utils/request'

export type RawSpaConfigResponse = {
  auth?: {
    issuer: string
    clientId: string
    redirectUri?: string
  }
  monitorConfig?: {
    config: {
      guestRoleArn: string
      identityPoolId: string
    }
    appMonitorId: string
    region: string
  }
  ui: {
    headerLogo: {
      '138x36': string
    }
    signupLogo: {
      '300x78': string
    }
    signupBackgroundColour: string
    crystalTheme: {
      colors: {
        primary: string
        secondary: string
        positive: string
        warning: string
        negative: string
        magic: string
      }
    }
    favicon: string
  }
  school?: {
    name: string
  }
}

export type SpaConfig = {
  isLoading: boolean
  config?: {
    issuer: string
    clientId: string
    redirectUri?: string
  } | null
  monitorConfig?: {
    config: {
      guestRoleArn: string
      identityPoolId: string
    }
    appMonitorId: string
    region: string
  }
  ui: RawSpaConfigResponse['ui'] | null
  school: { name: string }
}

export function useGetSpaConfig(): SpaConfig {
  const { isLoading, data } = useQuery({
    queryKey: ['spaConfig'],
    queryFn: async () => {
      const response = await request<RawSpaConfigResponse>(
        new ApiAgentRequest(`/spa-config`, { method: 'GET' }),
        {
          isExpectedResponse: (res): res is RawSpaConfigResponse => res as boolean,
        },
      )
      return response
    },
    enabled: true,
    refetchOnWindowFocus: false,
    retry: false,
  })

  return {
    isLoading: isLoading,
    config: data?.auth,
    monitorConfig: data?.monitorConfig,
    ui: data?.ui ?? null,
    school: data?.school ?? { name: '' },
  }
}
